import React, { Component } from "react";
import {mapPerformanceSteps,uploadFileInstruction,mapType,reviewInstruction} from '../../../utils/constants';
import Steps from '../../../components/Steps/Steps';
import UploadFile from '../Components/UploadFile/UploadFile';
import MatchColumns from '../Components/MatchColumns/MatchColumns';
import Review from './../Components/Review/Review';
import MapColumns from './../Components/MapColumns/MapColumns';
import groupBy from 'lodash/groupBy';
import find from 'lodash/find';
import uniqBy from 'lodash/uniqBy';
import remove from 'lodash/remove';
import findIndex from 'lodash/findIndex';
import flatten from 'lodash/flattenDeep';
import filter from 'lodash/filter';
import sortBy from 'lodash/sortBy';
import { deepClone } from "../../../utils/copyObject";
import axios from './../../../axios';
import * as url from './../../../utils/url';

export default class MapPerformance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchedTerm : '',
      sortType : 'unmapped-first',
      performanceOptions : [],
      perMapping:[],
      error:false
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    let options 
    const orgID = this.props.user.organizationId._id

    axios.get(url.getMasterListByCategory('PERFORMANCE')).then(({data}) => {
      const payload = data.data[0].docs;
      // console.log(payload)
       options = payload.map((i) => {
        const o = {};
        o.value = i._id;
        o.label = i.name;
        return o;
      });
      this.setState({
        performanceOptions : options
      })
    })
}

  handleFileUpload = (fields, data, file) => {
    const {matchedColumn} = this.props.mapPerformance;
    
    // console.log("fields : ",fields,"includes : ",file, '--', data);
    if(matchedColumn.length > 0) {
      if(!fields.includes(matchedColumn)) {
        this.props.onMatchColumn("");
      }
    }
    this.props.onProcessedFileUploadData(fields, data, file);
    this.props.nextStep();
    // console.log("on handle file upload");
  }

  handleMapPerformanceColumnContinue = () => {
    const prevMap = this.state.perMapping
    let err = this.state.error
    let {allPerformanceMapping} = this.props.mapPerformance;
    const invalidRecords = filter(allPerformanceMapping,(o) => o.mapped && !o.column && o.column!=="");
    // console.log('invalid ---', invalidRecords)
    if(invalidRecords.length>0){
      this.setState({error:"Please map previously mapped values"})
      return
    } else {
      this.setState({error:false})
        this.props.nextStep()
    }
  }

  handlePerformanceMapped = (performance,column) => {
    // console.log(performance,"--p---", column)
    const {allPerformanceMapping} = this.props.mapPerformance;
    let allPerformances = deepClone(allPerformanceMapping);
    const i = findIndex(allPerformances,{value : performance.value});
    allPerformances.splice(i,1,{value:performance.value,column:column, mapped:performance.mapped})
    this.props.saveAllPerformanceMapping(allPerformances);
  }

  handleMatchPerformanceColumn = (matchedColumn) => {
    let {rowData,allPerformanceMapping} = this.props.mapPerformance;
    const {isRepeatFlow} = this.props;
    const uP = Object.keys(groupBy(rowData,(r) => r[matchedColumn]));
    const uniquePerformance = uP.filter(e => e!=="null")
    // console.log(uniquePerformance, isRepeatFlow);
    // console.log(allPerformanceMapping);
    this.props.onMatchColumn(matchedColumn);
    let options = this.state.performanceOptions
    const orgID = this.props.user.organizationId._id


    if(isRepeatFlow) {
      axios.get(url.getExistingMappings(orgID)).then(({data}) => {
        const payload = data.data;
        let {mapping} = payload;
        // console.log('mppaing --- ', mapping)
        if(mapping.performance && mapping.performance.data ){
          allPerformanceMapping=[]
          // console.log('inside')
          mapping.performance.data.map(e=>{
            let column = e.key
            let obj;
              e.values.map(c=>{
                let cVal = find(options, {label:e.key})
                // console.log('va--', cVal)
                obj = {column:{value: cVal.value, label:e.key}, value: c, mapped:true}
                return allPerformanceMapping.push(obj)
              })
          })
        // console.log('all ---', allPerformanceMapping)
        this.props.saveAllPerformanceMapping(allPerformanceMapping)  

        if(allPerformanceMapping.length>0){
          const filteredMapping = uniquePerformance.map((f) => {
            const found = find(allPerformanceMapping,(o) => o.value === f);
            if(found) {
              return {
                value : f,
                column : found.column,
                mapped:true
              }
            } else {
              return {
                value : f,
                column : '',
                mapped:false
              }
            }
          })
         
          //  console.log(filteredMapping,'--',allPerformanceMapping);
           let results = allPerformanceMapping.concat(filteredMapping)
           let res = results.filter(e=> e.value!=null && e.value!='null').map(e=>{
             if(e.column!==""){
               let obj = {
                 value:e.value,
                 mapped: e.mapped,
                 column: {label:e.column!==""?e.column.label:"",value: e.column?e.column.value:""}
               }
               return obj
             } else {
               let val = e.value===undefined||e.value===null ||e.value==="null"|| e.value==="undefined"? e.value="empty":e.value
               let obj = {
                 value:val,
                 mapped: false,
                 column: ""
               }
               return obj
             }
           })
           res = uniqBy(res, 'value')
           this.props.saveAllPerformanceMapping(res);
           this.props.nextStep();
        } else {
        this.props.saveAllPerformanceMapping(sortBy(filter(uniquePerformance,(p) => p != 'undefined').map((p) => {
          const g = {};
          g.value = p;
          g.column = ''
          return g;
        }),(o) => o.value));
        this.props.nextStep();
      }
    } else {
      this.props.saveAllPerformanceMapping(sortBy(filter(uniquePerformance,(p) => p != 'undefined').map((p) => {
        const g = {};
        g.value = p;
        g.column = ''
        return g;
      }),(o) => o.value));
      this.props.nextStep();
    }
    })
  }else {
    this.props.saveAllPerformanceMapping(sortBy(filter(uniquePerformance,(p) => p != 'undefined').map((p) => {
      const g = {};
      g.value = p;
      g.column = ''
      return g;
    }),(o) => o.value));
    this.props.nextStep();
  }
  

  }

  handleSearchQueryChange = ({name,value}) => {
    this.setState({
      searchedTerm : value
    })
  }

  handleContinue = () => {
    let {allPerformanceMapping} = this.props.mapPerformance;
    const {isRepeatFlow} = this.props;
    allPerformanceMapping = filter(allPerformanceMapping,(m)=> m.column)
    // console.log('pp-----', allPerformanceMapping)
    const groupedMapping = groupBy(allPerformanceMapping,(m) =>  m.column.value);
    // console.log('g mapp 109 -- ' ,groupedMapping);
    let data = [];
    for(let key in groupedMapping) {
      // console.log(groupedMapping[key]);
      data.push({
        key : key,
        values : groupedMapping[key].map((o) => o.value)
      })
    }
    data = data.filter(o => o.key!==undefined && o.key!=="undefined")
    // console.log(data);
    data = data.filter(o => o.key!==undefined && o.key!=="undefined")

    const {matchedColumn} = this.props.mapPerformance;
    // console.log(matchedColumn);
    const payload = {
      mappingType : "performance",
      columnName : matchedColumn,
      data : data
    }
    // console.log(payload);
    axios.post(url.saveMapping,payload).then(({data}) => {
      if(isRepeatFlow) {
        this.props.history.push({pathname : 'success',state : {type : 'performance'}});
        this.props.reset();
      } else {
        this.props.history.push('/setup/map-separation');
      }
    })
  }

  handleonSortChange = (sortType) => {
    this.setState({
      sortType : sortType
    });
  }

  handleSkipStep = () => {
    axios.post(url.skipStepFor('performance')).then(({data}) => {
      this.props.history.push('/setup/map-separation');
    })
  }

  render() {
    console.log(this.props);
    let {currentStep, allColumns, rowData, file, matchedColumn, 
      allPerformanceMapping} = this.props.mapPerformance;
    const {searchedTerm,sortType,performanceOptions} = this.state;
    const {isRepeatFlow} = this.props;
    const existingMap = this.state.perMapping
    // console.log(performanceOptions)
    return (
      <div className={"mb30" + isRepeatFlow ? 'mt30' : 'mt70'}>
      <div className="map-performance-title mt30 mb30">Map Performance</div>
        <Steps steps={mapPerformanceSteps} currentStep={currentStep} />
        {
          currentStep === 1 ? 
          <UploadFile
            top="mt40"
            instruction={uploadFileInstruction.mapPerformance}
            allColumns={allColumns}
            rowData={rowData}
            file={file}
            type={mapType.performance}
            labelSize={4}
            labelText="File with Performance Ratings"
            allowedFileSize={20}
            uploadFileHint="(Only .csv files, maximum 20MB file size)"
            onFileUpload={this.handleFileUpload}
            onSkipStep={this.handleSkipStep}
            isRepeatFlow={isRepeatFlow}
          /> : 
          currentStep === 2 ?
            <MatchColumns
              goBack={this.props.goBack}
              top="mt40"
              instruction={`Please match the column with performance ratings.`}
              csvFields = {allColumns}
              csvData = {rowData}
              type={mapType.performance}
              mappingPositions={true}
              showDropdown={false}
              matchedColumns={matchedColumn!=="" ? [matchedColumn] : []}
              allowMoreColumnsMatch={false}
              nextBtnTxt='Continue'
              onMatchedColumn={this.handleMatchPerformanceColumn}
            /> : 
          currentStep === 3 ?
            <MapColumns
              allDataMapping={allPerformanceMapping}
              existingMap={existingMap}
              mapOptions={performanceOptions}
              onRowMapped={this.handlePerformanceMapped}
              nextStep={this.handleMapPerformanceColumnContinue}
              goBack={this.props.goBack}
              searchedTerm={searchedTerm}
              sortType={sortType}
              error={this.state.error}
              onSearchQueryChange={this.handleSearchQueryChange}
              onSortChange={this.handleonSortChange}
              type={mapType.performance}
              mapSelectPlaceholder="Map performance"
              optionTypeTxt="Grade Name"
              mappingTableHeader="Performance Grade Name"
              searchBarPlaceholder="Search by performance grade name"
              mappingSubHeaderTxt="Please map your employees' performance information to standardized performance ratings."
            /> :
          currentStep === 4 ?
            <Review
              top="mt40"
              instruction={reviewInstruction.mapPerformance}
              goBack={this.props.goBack}
              nextBtnAction={this.handleContinue}
              type={mapType.performance}
              mapOptions={performanceOptions}
              file={file}
              nextBtnTxt={isRepeatFlow ? 'Finish' : 'Next Step'}
              isRepeatFlow={isRepeatFlow}
              reviewHeading="These are your final selections for the mapping. "
              {...this.props}/>
            :
            null
        }
    </div>
    );
  }
}